module.exports = __webpack_public_path__ + "static/media/Elephant2.894d2398.png";